module.exports = __webpack_public_path__ + "img/aneuplan.1bc3be24.png";